module.exports = __webpack_public_path__ + "img/delete.0304c68c.svg";